<template>
  <v-card class="show institution" v-if="institution">
    <v-card-title primary-title>
      <can I="edit" a="Institution">
        <LogoUpload
          :src="institution.logo"
          :path="`/admin/institutions/${institution.id}/logo`"
          @success="logoSuccess"
        />
      </can>
      <div>
        <div class="headline">{{ institution.name }}</div>
        <span class="subheading grey--text">{{ institution.acronym }}</span>
      </div>
    </v-card-title>

    <v-divider />

    <!-- Attributes table -->
    <table class="v-table theme--dark">
      <tbody>
        <tr>
          <th class="text-xs-right">ID</th>
          <td>{{ institution.id }}</td>
        </tr>
        <tr>
          <th class="text-xs-right">Name</th>
          <td>{{ institution.name }}</td>
        </tr>
        <tr>
          <th class="text-xs-right">Acronym</th>
          <td v-if="institution.acronym">{{ institution.acronym }}</td>
          <td v-else><em>None</em></td>
        </tr>
        <tr>
          <th class="text-xs-right">Default Grade Scale</th>
          <td v-if="institution.gradeScale">{{ institution.gradeScale }}</td>
          <td v-else><em>None</em></td>
        </tr>
        <tr>
          <th class="text-xs-right">Formerly</th>
          <td v-if="institution.formerNames && institution.formerNames.length">
            <v-chip v-for="name in institution.formerNames" :key="name">{{ name }}</v-chip>
          </td>
          <td v-else><em>None</em></td>
        </tr>

        <tr v-if="institution.updatedAt">
          <th class="text-xs-right">Last updated</th>
          <td>
            {{ new Date(institution.updatedAt) | date("h:mm a, MMMM do yyyy") }}
            ({{ new Date(institution.updatedAt) | inWords({ addSuffix: true }) }})
          </td>
        </tr>

        <tr v-if="institution.createdAt">
          <th class="text-xs-right">Created</th>
          <td>
            {{ new Date(institution.createdAt) | date("h:mm a, MMMM do yyyy") }}
            ({{ new Date(institution.createdAt) | inWords({ addSuffix: true }) }})
          </td>
        </tr>
      </tbody>
    </table>
    <v-divider />
    <v-card-actions><v-spacer />
      <can I="delete" a="Institution">
        <v-dialog v-model="dialog" lazy max-width="600px">
          <v-btn flat color="error" slot="activator">
            <v-icon left>mdi-delete</v-icon> Delete
          </v-btn>

          <v-card dark>
            <v-card-title>
              <div class="headline">Are you sure?</div>
            </v-card-title>
            <v-card-text>Deleting an institution is not reversable.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click.native="dialog = false" color="grey">cancel</v-btn>
              <v-btn color="error" @click="destroy">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </can>
      <can I="edit" a="Institution">
        <v-btn color="primary" @click.prevent="$emit('edit')">
          <v-icon left>mdi-pencil</v-icon> Edit
        </v-btn>
      </can>
    </v-card-actions>
  </v-card>
</template>

<script>
// Components
import LogoUpload from '@/components/LogoUpload'

// Vue Component
export default {
  components: { LogoUpload },
  data() {
    return { dialog: false }
  },
  computed: {
    institution() { return this.$store.getters['admin/institutions/find'](this.$route.params.id) }
  },
  methods: {
    destroy() {
      this.$emit('destroy')
    },
    logoSuccess() {
      this.$store.commit('snackbar', { text: 'Logo uploaded!', type: 'success' })
      this.$store.dispatch('admin/institutions/fetch', this.institution.id)
    }
  }
}
</script>
